const companyreport = `
    billingFrom
    billingTo
    companyName
    created
    delete
    documentCreationDate
    id
    numberOfPages
    reportType
    startingPage
    usageFrom
    usageTo
    tenantAddressOnReport {
        streetName
        houseNumber
        postalCode
        city
    }
`;

export default companyreport;